import { ThemeOptions } from '@mui/material';
import type {} from '@mui/material/Paper';
// tslint:disable:interface-name
declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    drawer: true;
  }
}

export const MuiPaper: ThemeOptions['components']['MuiPaper'] = {
  variants: [
    {
      props: { variant: 'drawer' },
      style: ({ theme }) => ({
        // Note: elevation is set via the elevation prop in Drawer.tsx, not CSS
        backgroundColor: theme.palette.background.default,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      })
    }
  ]
};
